import { useNavigate } from 'react-router-dom';
import React, { useState, useMemo } from 'react';
import {
  case_completed,
  case_submitted,
  documenticon,
  imagesend,
  mascot_img_main,
  case_rush,
  waiting_icon
} from '../../imagepath';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import BreadCrumbs from '../../core/BreadCrumbs';
import { Button, Typography, Select } from 'antd';
import { useDashboard } from '../../../hooks/dashboard/useDashboard';
import { useUserProfile } from '../../../hooks/useUserProfile';
import dayjs from 'dayjs';
const { Text } = Typography;
const { Option } = Select;

const BREAD_CRUMBS = [{ label: 'Dashboard', to: '/user/admin-dashboard' }];

const DATE_RANGE_OPTIONS = {
  LAST_7_DAYS: 'last_7_days',
  LAST_15_DAYS: 'last_15_days',
  LAST_30_DAYS: 'last_30_days',
  CURRENT_MONTH: 'current_month',
  LAST_3_MONTHS: 'last_3_months',
  LAST_6_MONTHS: 'last_6_months',
  LAST_1_YEAR: 'last_1_year',
};

const Admin_Dashboard = () => {
  const { userProfile } = useUserProfile();
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState(DATE_RANGE_OPTIONS.CURRENT_MONTH);

  // Calculate date range based on selected filter
  const filterParams = useMemo(() => {
    const today = dayjs().endOf('day');
    let startDate, endDate;

    switch (selectedFilter) {
      case DATE_RANGE_OPTIONS.LAST_7_DAYS:
        startDate = today.subtract(7, 'day').startOf('day');
        endDate = today;
        break;
      case DATE_RANGE_OPTIONS.LAST_15_DAYS:
        startDate = today.subtract(15, 'day').startOf('day');
        endDate = today;
        break;
      case DATE_RANGE_OPTIONS.LAST_30_DAYS:
        startDate = today.subtract(30, 'day').startOf('day');
        endDate = today;
        break;
      case DATE_RANGE_OPTIONS.CURRENT_MONTH:
        startDate = today.startOf('month');
        endDate = today;
        break;
      case DATE_RANGE_OPTIONS.LAST_3_MONTHS:
        startDate = today.subtract(3, 'month').startOf('day');
        endDate = today;
        break;
      case DATE_RANGE_OPTIONS.LAST_6_MONTHS:
        startDate = today.subtract(6, 'month').startOf('day');
        endDate = today;
        break;
      case DATE_RANGE_OPTIONS.LAST_1_YEAR:
        startDate = today.subtract(1, 'year').startOf('day');
        endDate = today;
        break;
      default:
        startDate = today.subtract(7, 'day').startOf('day');
        endDate = today;
    }

    return {
      startDate: startDate?.toISOString(),
      endDate: endDate?.toISOString(),
    };
  }, [selectedFilter]);

  const { data } = useDashboard(filterParams);

  return (
    <div>
      <div>
        {/* /Page Header */}
        <BreadCrumbs items={BREAD_CRUMBS} />
        <div className="good-morning-blk">
          <div className="row">
            <div className="col-md-6 col-lg-8 col-xl-8">
              <div className="morning-user">
                <h2>
                  Good Morning, <span>{userProfile?.fullName}</span>
                </h2>
                <p>Have a nice day at work</p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4 position-blk">
              <div className="morning-img">
                <img src={mascot_img_main} alt="#" height={150} width={150} />
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-12">
            <div className="d-flex align-items-center gap-3">
              <Text strong>Measurement:</Text>
              <Select
                value={selectedFilter}
                onChange={(value) => {
                  setSelectedFilter(value);
                }}
                style={{ minWidth: 200 }}
              >
                {/* <Option value={DATE_RANGE_OPTIONS.LAST_7_DAYS}>Last 7 days</Option>
                <Option value={DATE_RANGE_OPTIONS.LAST_15_DAYS}>Last 15 days</Option>
                <Option value={DATE_RANGE_OPTIONS.LAST_30_DAYS}>Last 30 days</Option> */}
                <Option value={DATE_RANGE_OPTIONS.CURRENT_MONTH}>Current Month</Option>
                <Option value={DATE_RANGE_OPTIONS.LAST_3_MONTHS}>Last 3 months</Option>
                <Option value={DATE_RANGE_OPTIONS.LAST_6_MONTHS}>Last 6 months</Option>
                <Option value={DATE_RANGE_OPTIONS.LAST_1_YEAR}>Last 1 year</Option>
              </Select>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
            <div className="dash-widget h-100">
              <div className="dash-boxs comman-flex-center">
                <img src={case_completed} alt="#" />
              </div>
              <div className="dash-content dash-count d-flex flex-column">
                <h4>Completed <br />Cases</h4>
                <h2 className="flex-grow-1 d-flex align-items-center">
                  <CountUp
                    delay={0.4}
                    end={data?.completedCases}
                    duration={0.6}
                  />
                </h2>
                <Button
                  size="small"
                  type="link"
                  className="p-0 mt-auto"
                  onClick={() => navigate('/user/case/completed')}
                >
                  View All
                </Button>
              </div>
            </div>
          </div>

          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
            <div className="dash-widget h-100">
              <div className="dash-boxs comman-flex-center">
                <img src={case_submitted} alt="#" />
              </div>
              <div className="dash-content dash-count d-flex flex-column">
                <h4>Submitted  <br />Cases</h4>
                <h2 className="flex-grow-1 d-flex align-items-center">
                  <CountUp
                    delay={0.4}
                    end={data?.submittedCases}
                    duration={0.6}
                  />
                </h2>
                <Button
                  size="small"
                  type="link"
                  className="p-0 mt-auto"
                  onClick={() => navigate('/user/case/submitted')}
                >
                  View All
                </Button>
              </div>
            </div>
          </div>

          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
            <div className="dash-widget h-100">
              <div className="dash-boxs comman-flex-center">
                <img src={case_rush} alt="#" />
              </div>
              <div className="dash-content dash-count d-flex flex-column">
                <h4>Rush <br /> Cases</h4>
                <h2 className="flex-grow-1 d-flex align-items-center">
                  <CountUp
                    delay={0.4}
                    end={data?.rushCases}
                    duration={0.6}
                  />
                </h2>
                <Button
                  size="small"
                  type="link"
                  className="p-0 mt-auto"
                  onClick={() => navigate('/user/case/submitted?rushOnly=true')}
                >
                  View All
                </Button>
              </div>
            </div>
          </div>

          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
            <div className="dash-widget h-100">
              <div className="dash-boxs comman-flex-center">
                <img src={waiting_icon} alt="#" />
              </div>
              <div className="dash-content dash-count d-flex flex-column">
                <h4>Awaiting <br />Approval</h4>
                <h2 className="flex-grow-1 d-flex align-items-center">
                  <CountUp
                    delay={0.4}
                    end={data?.waitingApprovalsCases}
                    duration={0.6}
                  />
                </h2>
                <Button
                  size="small"
                  type="link"
                  className="p-0 mt-auto"
                  onClick={() => navigate('/user/case/awaiting-approval')}
                >
                  View All
                </Button>
              </div>
            </div>
          </div>

          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
            <div className="dash-widget h-100">
              <div className="dash-boxs comman-flex-center">
                <img src={documenticon} alt="#" />
              </div>
              <div className="dash-content dash-count d-flex flex-column">
                <h4>Invoices</h4>
                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                  <h2 className="mb-1">
                    <CountUp
                      delay={0.4}
                      end={data?.invoicesCount}
                      duration={0.6}
                    />
                  </h2>
                  <Text className="small">
                    Value: <Text strong>
                      $<CountUp
                        delay={0.4}
                        end={data?.invoicesValue}
                        duration={0.6}
                      />
                    </Text>
                  </Text>
                </div>
                <Button
                  size="small"
                  type="link"
                  className="p-0 mt-auto"
                  onClick={() => navigate('/user/invoicelist')}
                >
                  View All
                </Button>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
            <div className="dash-widget h-100 d-flex align-items-center justify-content-center">
              <div className="dash-content dash-count">
                <Button
                  size="small"
                  type="link"
                  className="mt-auto"
                  onClick={() => navigate('/user/cliniclist')}
                  icon={<i className='fa fa-eye'></i>}
                >
                  Clinics
                </Button>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12 mb-3">
            <div className="dash-widget h-100 d-flex align-items-center justify-content-center">
              <div className="dash-content dash-count">
                <Button
                  size="small"
                  type="link"
                  className="mt-auto"
                  onClick={() => navigate('/user/radiologistlist')}
                  icon={<i className='fa fa-plus'></i>}
                >
                  Radiologist
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="delete_patient"
        className="modal fade delete-modal"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <img src={imagesend} alt="#" width={50} height={46} />
              <h3>Are you sure want to delete this ?</h3>
              <div className="m-t-20">
                {' '}
                <Link
                  to="#"
                  className="btn btn-white me-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </Link>
                <button type="submit" className="btn btn-danger">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {' '}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button type="submit" className="btn btn-danger">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin_Dashboard;
